import { get } from "lodash";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import FilterContainer from "src/components/TableV2/FilterContainer";
import SearchField from "src/components/TableV2/SearchField";
import DisTable from "src/components/TableV2/Table";
import Title from "src/components/TableV2/Title";
import { useLoading } from "src/hooks/useLoading";
import { IApplication } from "src/store/models/application.model";
import { fetchApplicationsList } from "src/store/reducers/applicationCommand";
import StatusFilterTool from "../../components/TableV2/StatusFilter";
import * as S from "../../constants/StringConstants";
import { applicationsPageColumns } from "../Applications/constants";

import { useLocalStorage } from "src/hooks/useLocalStorage";
import { IRootState } from "src/store/reducers";
import { fetchApplicationOptions } from "src/store/reducers/applicationBuilder";
import { addDefaultOption } from "src/util/utils.defaultValues";
import "./ApplicationsTable.scss";

interface ApplicationsTableProps {
  date: string | Date;
}

const ApplicationsTable = (props: ApplicationsTableProps) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { setIsLoading } = useLoading();
  const [selectedStatus, setSelectedStatus] = useLocalStorage<string | null>("applicationSelectedStatusV3", null);

  const tableRef = useRef<any>(null);

  const { statusOptions, userId } = useSelector((state: IRootState) => ({
    statusOptions: state.applicationBuilder.selectStatusList,
    userId: state.auth.user.userID as any,
  }));

  useEffect(() => {
    tableRef.current?.update();
  }, [props.date]);

  useEffect(() => {
    dispatch(fetchApplicationOptions());
  }, []);

  return (
    <DisTable<IApplication>
      columns={applicationsPageColumns()}
      initialState={{ query: { statusIds: selectedStatus } }}
      getRef={ft => {
        tableRef.current = ft;
      }}
      onRowClick={(data: IApplication) => {
        history.push(`/applications/${data.id}`);
      }}
      onUpdate={async ({ page, rows, sort, query }) => {
        setIsLoading(true);
        const result: any = await dispatch(
          fetchApplicationsList({
            page,
            rows,
            sort,
            query: {
              createdById: userId,
              // ...getDateRangeForDate(props?.date, ["reviewFromDate", "reviewToDate"]),
              ...query,
            },
          }),
        );
        setIsLoading(false);
        if (selectedStatus !== query.statusIds) {
          setSelectedStatus(query.statusIds);
        }

        return {
          total: get(result, "value.data.totalRows") as number,
          data: get(result, "value.data.items") as IApplication[],
        };
      }}>
      <FilterContainer
        left={<Title text={S.APP_TABLE_TITLE} />}
        right={
          <>
            <StatusFilterTool
              key="statusID"
              fieldName="statusIds"
              fieldLabel={S.APP_FILTERS_STATUS}
              statusList={addDefaultOption(S.APP_TABLE_ALL, statusOptions)}
            />
            <SearchField placeholder={S.APP_TABLE_SEARCH_PLACEHOLDER} inputStyle={{ width: "30rem" }} />
          </>
        }></FilterContainer>
    </DisTable>
  );
};

export default ApplicationsTable;
